import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { SharedClassroomToolbarDataAccessModule } from "shared/classroom/toolbar/data-access";
import { MatButtonModule } from "@angular/material/button";
import { SharedUiDirectivesModule } from "shared/ui/directives";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { ColorPaletteComponent } from "./components/color-palette/color-palette.component";
import { GoToParentSlideButtonComponent } from "./components/go-to-parent-slide-button/go-to-parent-slide-button.component";
import { ToolbarButtonComponent } from "./components/toolbar-button/toolbar-button.component";
import { ToolbarButtonPencilComponent } from "./components/toolbar-button/toolbar-button-pencil/toolbar-button-pencil.component";
import { ToolbarButtonArrowComponent } from "./components/toolbar-button/toolbar-button-arrow/toolbar-button-arrow.component";
import { ToolbarButtonEllipseComponent } from "./components/toolbar-button/toolbar-button-ellipse/toolbar-button-ellipse.component";
import {
    ToolbarButtonColorPaletteComponent
} from "./components/toolbar-button/toolbar-button-color-palette/toolbar-button-color-palette.component";
import {
    ToolbarButtonBookpageListComponent
} from "./components/toolbar-button/toolbar-button-bookpage-list/toolbar-button-bookpage-list.component";
import { ToolbarButtonSelectComponent } from "./components/toolbar-button/toolbar-button-select/toolbar-button-select.component";
import {
    ToolbarButtonGoToParentSlideComponent
} from "./components/toolbar-button/toolbar-button-go-to-parent-slide/toolbar-button-go-to-parent-slide.component";
import { ToolbarButtonUndoComponent } from "./components/toolbar-button/toolbar-button-undo/toolbar-button-undo.component";
import { ToolbarButtonRedoComponent } from "./components/toolbar-button/toolbar-button-redo/toolbar-button-redo.component";
import { ToolbarButtonDividerComponent } from "./components/toolbar-button/toolbar-button-divider/toolbar-button-divider.component";
import { ToolbarButtonDividerWideComponent } from "./components/toolbar-button/toolbar-button-divider-wide/toolbar-button-divider-wide.component";
import { PcpSlideSyncBookpageDialogModule } from "./components/bookpage-dialog/bookpage-dialog.module";
import { EffectsModule } from "@ngrx/effects";
import { BookpageEffects } from "./effects/bookpage.effects";
import { ToolbarButtonDrawingMenuComponent } from './components/toolbar-button/toolbar-button-drawing-menu/toolbar-button-drawing-menu.component';
import { StrokeWidthComponent } from './components/stroke-width/stroke-width.component';
import { DrawingMenuComponent } from './drawing-menu/drawing-menu.component';
import { FloatingToolbarComponent } from './components/floating-toolbar/floating-toolbar.component';
import { CdkDragHandle } from "@angular/cdk/drag-drop";

@NgModule({
    imports: [
        CommonModule,
        MatDividerModule,
        MatIconModule,
        SharedClassroomToolbarDataAccessModule,
        PcpSlideSyncBookpageDialogModule,
        MatButtonModule,
        SharedUiDirectivesModule,
        EffectsModule.forFeature([
            BookpageEffects,
        ]),
        CdkDragHandle,
        ToolbarComponent,
        FloatingToolbarComponent,
        ColorPaletteComponent,
        StrokeWidthComponent,
        GoToParentSlideButtonComponent,
        ToolbarButtonComponent,
        ToolbarButtonPencilComponent,
        ToolbarButtonArrowComponent,
        ToolbarButtonEllipseComponent,
        ToolbarButtonColorPaletteComponent,
        ToolbarButtonBookpageListComponent,
        ToolbarButtonSelectComponent,
        ToolbarButtonGoToParentSlideComponent,
        ToolbarButtonUndoComponent,
        ToolbarButtonRedoComponent,
        ToolbarButtonDividerComponent,
        ToolbarButtonDividerWideComponent,
        ToolbarButtonDrawingMenuComponent,
        DrawingMenuComponent,
    ],
    exports: [
        ToolbarComponent,
        FloatingToolbarComponent,
        ToolbarButtonPencilComponent,
        ToolbarButtonArrowComponent,
        ToolbarButtonEllipseComponent,
        ToolbarButtonColorPaletteComponent,
        ToolbarButtonBookpageListComponent,
        ToolbarButtonSelectComponent,
        ToolbarButtonGoToParentSlideComponent,
        ToolbarButtonUndoComponent,
        ToolbarButtonRedoComponent,
        ToolbarButtonDividerComponent,
        ToolbarButtonDividerWideComponent,
        ToolbarButtonDrawingMenuComponent,
        DrawingMenuComponent,
    ],
})
export class SharedClassroomToolbarFeatureShellModule {}
